// File: frontend/src/pages/FitenkoObrashcheniya.js
// Version: 1.0 (quick-260911-27v)
// Date: 2026-09-11
// Назначение: экран `/leads` арендатора fitenko. ГРАНИЦА ИЗМЕРЕНИЯ ЦЕНЫ РИСУНКА:
//             весь рисунок этого экрана — этот файл и только он.
//
// 🔴 ПРЕДМЕТ ЭКРАНА — ОБРАЩЕНИЯ, А НЕ КЛИЕНТЫ (Д-01, Д-02). Лид не клиент: с
//    клиентом связаны проверка конфликта интересов и адвокатская тайна, и
//    назвать 109 обращений клиентами нельзя. `CONVERTED` на бою — 2.
//    РАСХОЖДЕНИЕ С АТЛАСОМ СДЕЛАНО НАРОЧНО: прототип показывает «Clients» и три
//    активных досье, мы показываем `Leads` и все обращения. Причина названа
//    здесь и в SUMMARY, чтобы следующий читатель не принял это за недосмотр.
//
// 🔴 ЗНАМЕНАТЕЛЬ ПРИХОДИТ С СЕРВЕРА И БОЛЬШЕ НИОТКУДА (Д-07). Длина массива в
//    знаменатель не ставится ни при каких условиях: ровно этим экран и врал —
//    «100 of 100» при 109 живых.
//
// 🔴 ОТБОР ПО СТРОКЕ И ПО СОСТОЯНИЮ ИДЁТ ПО УЖЕ ЗАГРУЖЕННЫМ СТРОКАМ. Число
//    отфильтрованного и `vsego` — РАЗНЫЕ величины, и подписаны они по-разному.
//    Слить их значило бы соврать числом снова, только в другую сторону.
//
// 🔴 В СТРОКЕ ОДНО ДЕЙСТВИЕ (Д-03, Д-04). Прежний экран держал на ста строках
//    четыреста кнопок, из них сто разрушительных — `Delete` без подтверждения
//    под курсором. `Delete` и `Convert` переехали на карточку обращения
//    (`/leads/:id`): возможность не потеряна, она унесена туда, где человек
//    смотрит на ОДНО обращение.
//
// 🔴 ТАБЛИЦА ОСТАЛАСЬ ТАБЛИЦЕЙ (Д-09). Сто девять строк карточками не читаются,
//    и у прототипа здесь тоже таблица. Применены токены и общий слой; новой
//    палитры не заведено, зашитых цветов в файле НОЛЬ.

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';

import apiService, { razobratSpisokObrashcheniy } from '../services/apiService';
import { ShapkaBezDeystviya, Sostoyanie } from '../components/FitenkoUzor';
import { LEGACY_DESTINATIONS } from '../config/fitenkoNav';
import { displayEmail, sourceMeta } from '../config/istochnikiObrashcheniy';
import { metkaYazyka, yazykOpoznan, neopoznannyeYazyki } from '../config/yazykiObrashcheniy';
import { metkaTipa } from '../config/historyEvents';
import { useUiLanguage } from '../context/UiLanguageContext';

// Размер страницы — ОДИН держатель на запрос и на подпись кнопки догрузки.
const NA_STRANICE = 100;

const SOSTOYANIYA = ['ALL', 'NEW', 'CONTACTED', 'QUALIFIED', 'UNQUALIFIED', 'CONVERTED'];

// 🔴 АДРЕС БЕРЁТСЯ ИЗ ДЕРЖАТЕЛЯ АДРЕСОВ, А НЕ ПИШЕТСЯ СТРОКОЙ. Второй держатель
//    разошёлся бы с первым молча — и разошёлся бы ровно в тот день, когда адрес
//    экрана поменяют в одном месте из двух.
const adresPoKlyuchu = (kluch) => {
    const d = LEGACY_DESTINATIONS.find((z) => z.key === kluch);
    return d ? d.path : null;
};

const kogda = (iso) => {
    if (!iso) return null;
    try {
        return new Date(iso).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit',
                                                      year: '2-digit', hour: '2-digit',
                                                      minute: '2-digit' });
    } catch (e) {
        return String(iso);
    }
};

// ─── Ячейки. Каждая обязана сказать словами, если показывать нечего. ─────────

const TegYazyka = ({ kod }) => {
    const metka = metkaYazyka(kod);
    if (!metka) return null;          // ПУСТО — тега нет вовсе, это не «незнакомо»
    const svoj = yazykOpoznan(kod);
    return (
        <span className={svoj ? 'fk-obr-lang' : 'fk-obr-lang fk-obr-lang-chuzhoj'}
              title={svoj ? undefined : 'код языка словарю не известен — показан как есть'}>
            {metka}
        </span>
    );
};

const YacheikaDela = ({ delo }) => {
    if (!delo || !delo.est) {
        return <span className="fk-obr-net">дела нет</span>;
    }
    return (
        <Link to={`/cases/${delo.nomer || delo.id}`} className="fk-obr-delo" style={{ textDecoration: 'none' }} title="Перейти в карточку дела">
            <span className="fk-obr-delo-name">{delo.nazvanie || '—'}</span>
            <span className="fk-obr-delo-num">№{delo.nomer}</span>
            {delo.zakryto ? <span className="fk-obr-delo-zakryto">закрыто</span> : null}
            {delo.ostalnyh > 0
                ? <span className="fk-obr-delo-esche">и ещё {delo.ostalnyh}</span>
                : null}
        </Link>
    );
};

const YacheikaSobytiya = ({ sobytie }) => {
    if (!sobytie || !sobytie.est) return <span className="fk-obr-net">событий нет</span>;
    return (
        <span className="fk-obr-sob">
            <span className="fk-obr-sob-tip">{metkaTipa(sobytie.tip)}</span>
            <span className="fk-obr-sob-kogda">{kogda(sobytie.kogda) || '—'}</span>
        </span>
    );
};

// ─── Экран ──────────────────────────────────────────────────────────────────

const FitenkoObrashcheniya = () => {
    const { t } = useUiLanguage();
    const [stroki, postavitStroki] = useState([]);
    const [vsego, postavitVsego] = useState(null);       // null = ещё не спрашивали
    const [gruzim, postavitGruzim] = useState(true);
    const [dogruzhaem, postavitDogruzhaem] = useState(false);
    const [otkaz, postavitOtkaz] = useState(null);       // ТРЕТЬЕ состояние
    const [stroka, postavitStroku] = useState('');
    const [sostoyanie, postavitSostoyanie] = useState('ALL');

    const sprosit = useCallback(async (skip) => {
        const otvet = await apiService.getLeads(skip, NA_STRANICE);
        const razbor = razobratSpisokObrashcheniy(otvet);
        if (razbor.rod === 'otkaz') {
            // ОТКАЗ ИЗМЕРИТЕЛЯ, а не «обращений нет». Пустая таблица здесь
            // соврала бы, и соврала бы молча.
            postavitOtkaz(razbor.tekst);
            return null;
        }
        postavitOtkaz(null);
        postavitVsego(razbor.vsego);
        return razbor;
    }, []);

    useEffect(() => {
        let zhiv = true;
        sprosit(0)
            .then((r) => { if (zhiv && r) postavitStroki(r.items); })
            .catch((e) => { if (zhiv) postavitOtkaz((e && e.message) || 'причина не названа'); })
            .finally(() => { if (zhiv) postavitGruzim(false); });
        return () => { zhiv = false; };
    }, [sprosit]);

    const dogruzit = useCallback(() => {
        postavitDogruzhaem(true);
        sprosit(stroki.length)
            .then((r) => { if (r) postavitStroki((bylo) => bylo.concat(r.items)); })
            .catch((e) => toast.error(`Догрузить не удалось: ${(e && e.message) || 'причина не названа'}`))
            .finally(() => postavitDogruzhaem(false));
    }, [sprosit, stroki.length]);

    const vidimye = useMemo(() => {
        const q = stroka.trim().toLowerCase();
        return stroki.filter((o) => {
            const poStroke = !q
                || [o.full_name, o.email, o.phone].some((v) => String(v || '').toLowerCase().includes(q));
            const poSostoyaniyu = sostoyanie === 'ALL' || o.status === sostoyanie;
            return poStroke && poSostoyaniyu;
        });
    }, [stroki, stroka, sostoyanie]);

    const chuzhieYazyki = useMemo(() => neopoznannyeYazyki(stroki), [stroki]);
    const otbiraem = Boolean(stroka.trim()) || sostoyanie !== 'ALL';
    // Кнопка исчезает, когда показывать больше нечего. Кнопка, которая ничего не
    // меняет, — флаг, который не переключает.
    const estEsche = vsego !== null && stroki.length < vsego;

    return (
        <div className="fk-page fk-obr">
            <ShapkaBezDeystviya
                nadzagolovok="INTAKE & PIPELINE"
                zagolovok="Leads"
                podstroka="Обращения из звонков Софии, веб-чата и форм сайта. Показ идёт страницами; дело и последняя активность приходят вместе со списком."
                nazadKuda={adresPoKlyuchu('dashboard')}
                nazadPodpis="← Назад к работе"
            />

            {/* 🔴 ДВА ЧИСЛА, И ОНИ ПОДПИСАНЫ ПО-РАЗНОМУ. «Показаны N из M» — про
                загруженное и про ВСЕХ живых; «после отбора» — про отбор по уже
                загруженным строкам. Одной подписью их слить нельзя. */}
            <div className="fk-obr-schet">
                {vsego === null
                    ? <span className="fk-obr-net">знаменатель не пришёл — сервер не назвал итог</span>
                    : <span className="fk-obr-schet-glav">Показаны {stroki.length} из {vsego}</span>}
                {otbiraem
                    ? <span className="fk-obr-schet-otbor">после отбора видно {vidimye.length}</span>
                    : null}
                {chuzhieYazyki.length > 0
                    ? <span className="fk-obr-schet-chuzhie">
                        кодов языка вне словаря: {chuzhieYazyki.length} ({chuzhieYazyki.join(', ')})
                      </span>
                    : null}
            </div>

            <div className="fk-obr-otbor">
                <input
                    className="fk-obr-pole"
                    type="text"
                    placeholder="Имя, почта или телефон — среди загруженных"
                    value={stroka}
                    onChange={(e) => postavitStroku(e.target.value)}
                />
                <select
                    className="fk-obr-pole fk-obr-vybor"
                    value={sostoyanie}
                    onChange={(e) => postavitSostoyanie(e.target.value)}
                >
                    {SOSTOYANIYA.map((s) => (
                        <option key={s} value={s}>{s === 'ALL' ? 'Любое состояние' : s}</option>
                    ))}
                </select>
            </div>

            {gruzim ? <Sostoyanie tekst="Гружу обращения…" /> : null}
            {!gruzim && otkaz
                ? <Sostoyanie tekst={`Список обращений спросить не удалось: ${otkaz}. Это отказ измерителя, а не «обращений нет».`} />
                : null}

            {!gruzim && !otkaz ? (
                <div className="fk-obr-obolochka">
                    <table className="fk-obr-tabl">
                        <thead>
                            <tr>
                                <th className="fk-obr-c1">ОБРАЩЕНИЕ</th>
                                <th className="fk-obr-c2">ДЕЛО</th>
                                <th className="fk-obr-c3">КОНТАКТЫ</th>
                                <th className="fk-obr-c4">ПОСЛЕДНЕЕ СОБЫТИЕ</th>
                                <th className="fk-obr-c5">ДЕЙСТВИЕ</th>
                            </tr>
                        </thead>
                        <tbody>
                            {vidimye.map((o) => (
                                <tr key={o.id}>
                                    <td className="fk-obr-c1">
                                        <span className="fk-obr-imya">
                                            {o.full_name || '—'}
                                            {o.has_new_activity && (
                                                <span className="badge-new-activity" style={{ marginLeft: '8px', fontSize: '0.72rem', padding: '2px 6px', borderRadius: '4px', backgroundColor: 'var(--accent-soft)', color: 'var(--accent-ink)', border: '1px solid var(--accent-border)', fontWeight: 600, display: 'inline-block' }}>
                                                    {t('practice.leads.badge_new_activity')}
                                                </span>
                                            )}
                                        </span>
                                        <span className="fk-obr-pod">
                                            <TegYazyka kod={o.language} />
                                            <span className="fk-obr-src">
                                                {sourceMeta(o.source).icon} {sourceMeta(o.source).label}
                                            </span>
                                        </span>
                                    </td>
                                    <td className="fk-obr-c2"><YacheikaDela delo={o.delo} /></td>
                                    <td className="fk-obr-c3">
                                        <span className="fk-obr-tel">{o.phone || '—'}</span>
                                        <span className="fk-obr-pochta">{displayEmail(o.email)}</span>
                                    </td>
                                    <td className="fk-obr-c4"><YacheikaSobytiya sobytie={o.sobytie} /></td>
                                    <td className="fk-obr-c5">
                                        <div style={{ display: 'inline-flex', gap: '6px', alignItems: 'center' }}>
                                            <Link className="fk-obr-act" to={`/history?lead=${o.id}`}>
                                                История
                                            </Link>
                                            {o.delo && o.delo.est && (
                                                <Link
                                                    className="fk-obr-act"
                                                    style={{ color: '#C8A653', fontWeight: '700' }}
                                                    to={`/cases/${o.delo.nomer || o.delo.id}`}
                                                    title="Перейти к делу"
                                                >
                                                    Дело →
                                                </Link>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {vidimye.length === 0 ? (
                                <tr>
                                    <td className="fk-obr-pusto" colSpan="5">
                                        {otbiraem
                                            ? 'Среди ЗАГРУЖЕННЫХ обращений совпадений нет. Это про загруженные, а не про всю фирму.'
                                            : 'Обращений нет ни одного.'}
                                    </td>
                                </tr>
                            ) : null}
                        </tbody>
                    </table>
                </div>
            ) : null}

            {!gruzim && !otkaz && estEsche ? (
                <button type="button" className="fk-obr-esche" onClick={dogruzit} disabled={dogruzhaem}>
                    {dogruzhaem ? 'Догружаю…' : `Показать ещё (осталось ${vsego - stroki.length})`}
                </button>
            ) : null}
        </div>
    );
};

export default FitenkoObrashcheniya;
